import React from 'react'

export default function LinearSettingsForm() {
  return (
    <div>
      <p>
        Linear is ready once installed. Use the conversation sidebar to create
        and link issues.
      </p>
    </div>
  )
}
